var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevrondownwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1423 20.8569C16.511 21.4881 15.4876 21.488 14.8563 20.8568L7.42649 13.427C6.79534 12.7958 6.79539 11.7724 7.42631 11.141C8.05755 10.5093 9.08163 10.5089 9.71309 11.1404L14.8627 16.2899C15.494 16.9212 16.5175 16.9212 17.1488 16.2899L22.2982 11.1405C22.9293 10.5094 23.953 10.5109 24.5823 11.1438C25.2091 11.7742 25.2076 12.7929 24.579 13.4215L17.1423 20.8569Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrondownwhite);
export default __webpack_public_path__ + "static/media/chevrondownwhite.e04b6f11d0910acac5af453d58bbf5a8.svg";
export { ForwardRef as ReactComponent };